// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTop_container__zDimv","container__button":"ScrollToTop_container__button__-7TJ4","container__button__animation":"ScrollToTop_container__button__animation__mnD9v"};